import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";

/** Create a new (empty) sketch. */
export function NewSketchDialog({ open, busy, onCreate, onClose }) {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    if (open) {
      setName("");
      setDescription("");
    }
  }, [open]);

  const valid = name.trim().length > 0;
  return (
    <Dialog open={open} onClose={busy ? undefined : onClose} fullWidth maxWidth="xs">
      <DialogTitle>New sketch</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          margin="dense"
          label="Sketch name"
          value={name}
          inputProps={{ maxLength: 150 }}
          onChange={(e) => setName(e.target.value)}
        />
        <TextField
          fullWidth
          margin="dense"
          multiline
          minRows={2}
          label="Description (optional)"
          value={description}
          inputProps={{ maxLength: 1000 }}
          onChange={(e) => setDescription(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={busy}>
          Cancel
        </Button>
        <Button
          variant="contained"
          disabled={!valid || busy}
          onClick={() =>
            onCreate({
              name: name.trim(),
              description: description.trim() || null,
            })
          }
        >
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
}

/**
 * Confirm dialog. With `inputLabel` it also collects text (min 3 chars) — used
 * for the mandatory reject remarks.
 */
export function ActionDialog({
  open,
  busy,
  title,
  message,
  confirmLabel = "Confirm",
  color = "primary",
  inputLabel,
  onConfirm,
  onClose,
}) {
  const [value, setValue] = useState("");

  useEffect(() => {
    if (open) setValue("");
  }, [open]);

  const needsText = Boolean(inputLabel);
  const valid = !needsText || value.trim().length >= 3;
  return (
    <Dialog open={open} onClose={busy ? undefined : onClose} fullWidth maxWidth="xs">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {message && <DialogContentText sx={{ mb: needsText ? 1 : 0 }}>{message}</DialogContentText>}
        {needsText && (
          <TextField
            autoFocus
            fullWidth
            multiline
            minRows={2}
            margin="dense"
            label={inputLabel}
            value={value}
            inputProps={{ maxLength: 1000 }}
            onChange={(e) => setValue(e.target.value)}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={busy}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color={color}
          disabled={!valid || busy}
          onClick={() => onConfirm(value.trim())}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
